import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { dismissFeedback } from 'entries/ducks';
import Feedback from 'entries/components/feedback';

const mapStateToProps = ({ entries: { feedbackGiven } }) => {
  return {
    feedbackGiven
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    onHide: dismissFeedback
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);



// WEBPACK FOOTER //
// ./entries/containers/feedback.js